<div class="settingsContent">
	<div class="roleAndDeviceSelection">
		<div class="formAndSaveButtonCon">
			<form class="roleAndDeviceSelectionForm" [formGroup]="dashboardSelectionFormGroup">
				<mat-form-field class="noHint" color="accent">
					<mat-label>{{ T.SETTINGS_PAGE_DASHBOARD_CONFIG_ROLE | translate }}</mat-label>
					<mat-select [formControl]="dashboardSelectionFormGroup.controls.role">
						@for (role of configurableRoles; track role) {
							<mat-option [value]="role.id">
								{{ role.name }}
							</mat-option>
						}
					</mat-select>
				</mat-form-field>

				<mat-form-field class="noHint" color="accent">
					<mat-label>{{ T.SETTINGS_PAGE_DASHBOARD_CONFIG_DEVICE_TYPE | translate }}</mat-label>
					<mat-select [formControl]="dashboardSelectionFormGroup.controls.clientType">
						@for (deviceType of configurableDevices; track deviceType) {
							<mat-option [value]="deviceType">
								{{ WebClientType[deviceType] }}
							</mat-option>
						}
					</mat-select>
				</mat-form-field>
			</form>

			<sim-button
				(onClick)="resetToDefault()"
				[disabled]="savingDashboard"
				[icon]="{fontSet: 'fad', fontIcon: 'fa-redo'}"
				[label]="T.USER_SETTINGS_DIALOG_RESET_DASHBOARD_TILES_TO_DEFAULT"
				style="margin-right: 10px"
				color="warn"
			/>

			@if (!noChanges() && !loadingDashboardTiles) {
				<sim-button
					(onClick)="discardCurrentChanges()"
					[@zoomInOnEnter]
					[disabled]="savingDashboard"
					[icon]="{fontSet: 'fad', fontIcon: 'fa-times'}"
					[label]="T.STAGE_DESIGNER_CHANGES_WARNING_OPTION_DISCARD"
					style="margin-right: 10px"
					color="warn"
				/>
			}

			<sim-button
				color="accent"
				(onClick)="saveDashboardTiles()"
				[appBusy]="saveSpecifigDashboardTilesPromise"
				[disabled]="noChanges() || loadingDashboardTiles"
				[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
				[label]="T.GLOBAL_TEXT_SAVE"
			/>
		</div>
	</div>

	<div class="dashboardConfiguration" [class.loading]="loadingDashboardTiles">
		<sim-component-loading-container
			[isLoading]="loadingDashboardTiles"
			[loadingMessage]="T.GLOBAL_TEXT_LOADING | translate"
			[showBackDrop]="true"
			loadingIcon="fa-columns fad"
		/>

		<div class="appGridContainer" [class.threeCols]="WebClientType.Tablet === dashboardSelectionFormGroup.controls.clientType.value">
			<div class="big">
				@for (appTilesIdx of [0, 1]; track appTilesIdx) {
					<div class="appTile">
						<ng-container
							[ngTemplateOutlet]="appTileWrapper"
							[ngTemplateOutletContext]="{
								$implicit: {size: 'big', index: appTilesIdx},
							}"
						/>
					</div>
				}
			</div>
			<div class="med">
				@for (appTilesIdx of [2, 3, 4]; track appTilesIdx) {
					<div class="appTile">
						<ng-container
							[ngTemplateOutlet]="appTileWrapper"
							[ngTemplateOutletContext]="{
								$implicit: {size: 'medium', index: appTilesIdx},
							}"
						/>
					</div>
				}
			</div>
			<div class="smallOne">
				@for (appTilesIdx of [5, 6, 7, 8]; track appTilesIdx) {
					<div class="appTile">
						<ng-container
							[ngTemplateOutlet]="appTileWrapper"
							[ngTemplateOutletContext]="{
								$implicit: {size: 'small', index: appTilesIdx},
							}"
						/>
					</div>
				}
			</div>
			@if (WebClientType.Tablet !== dashboardSelectionFormGroup.controls.clientType.value) {
				<div class="smallTwo">
					@for (appTilesIdx of [9, 10, 11, 12]; track appTilesIdx) {
						<div class="appTile">
							<ng-container
								[ngTemplateOutlet]="appTileWrapper"
								[ngTemplateOutletContext]="{
									$implicit: {size: 'small', index: appTilesIdx},
								}"
							/>
						</div>
					}
				</div>
			}
		</div>
	</div>
</div>

<ng-template #appTileWrapper let-options [ngAs]="TileData">
	<app-tile
		(moveDashboardTileClicked)="moveDashboardItem(options.index)"
		(moveDashboardTileDownClicked)="moveDashboardItemDown(options.index)"
		(moveDashboardTileUpClicked)="moveDashboardItemUp(options.index)"
		(removeDashboardTile)="removeDashboardTile(options.index)"
		*ngVar="currentApplicationTiles?.[options.index] as tile"
		[configMode]="true"
		[currentTileInEditModeIndex]="currentTileInEditMode"
		[permissionOverrule]="permissionOverrule"
		[size]="options.size"
		[tileAmount]="currentApplicationTiles.length"
		[tileIndex]="options.index"
		[tile]="tile"
	/>
</ng-template>
